import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { FormFieldConfig } from './form_field_config';
import { TemplateService } from 'src/app/services/template.service';
import { UserService } from 'src/app/admin/core/services/user.service';
import { SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.css'],
})
export class DropdownComponent implements OnInit {
  @Input() config: FormFieldConfig;
  @Input() data: any;
  value: any = {};
  // dropdownList: any = [];
  simpleMode = false;
  typeName: any;

  qrCode: string = 'Init';
  qrCodeDownloadLink: SafeUrl = '';

  constructor(
    private templateService: TemplateService,
    public userService: UserService
  ) { }

  ngOnInit(): void {

    if (!this.config.simpleMode) {
      // make a call to the bacend to get the dropdown values
      this.populateDropdown();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['config']) {
      this.config.id = '4';
      this.config = changes['config'].currentValue;
      this.typeName = this.config.typeName;
      this.simpleMode = this.config.simpleMode
      if (this.config.value) {
        this.value = this.config.value;
      }
    }

    if (this.config.name === 'qRCodeGeneration') {
      this.qrCode = this.config.uploadUrl;
    }
  }

  compareValeurs(o1: any, o2: any): boolean {
    if (o1 && o2) {
      return o1.id === o2.id;
    }
    return false;
  }

  populateDropdown() {
    if (this.config.entiteClassSelection) {
      this.populateFromEntite();
    } else if (this.config.parametreName || this.config.parameterLinkName) {
      this.populateFromParametre();
    }
  }

  populateFromParametre() {
    this.templateService
      .getDropDownValues(
        `parametre/nomtable/${this.config.parameterLinkName
          ? this.config.parameterLinkName
          : this.config.parametreName
        }`
      )
      .subscribe((data) => {
        this.config.dropdownList = data;
        const ids = [
          this.config.value?.parameterId
            ? this.config.value?.parameterId
            : this.config.value?.[0] ? this.config.value?.[0] : this.config.value,
        ];

        const val: any[] = [];
        ids?.forEach((id: string) => {
          if (id) {
            const v = this.config.dropdownList.find((el: any) => el.id === id);
            if (v) val.push(v);
          }
        });

        this.config.value = val[0] ? val[0] : null;
        this.value = this.config?.value;
      });
  }

  populateFromEntite() {
    this.templateService
      .getDropDownValues(`/${this.config.entity.toLocaleLowerCase()}/`)
      .subscribe((data) => {
        this.config.dropdownList = data;
      });
  }

  onChangeURL(url: SafeUrl) {
    this.qrCodeDownloadLink = url;
  }
}
